import { useMutation } from "@/core/api/graphql/composables";
import { UpdateCustomerOrderCommentDocument } from "@/core/api/graphql/types";

export function useUpdateCustomerOrderCommentMutation() {
  return useMutation(UpdateCustomerOrderCommentDocument);
}
